export class Tsacredential {
  id: number;
  tsaproviderId: number;
  username: string;
  password: string;
  url: string;
  createAt: string;
  active: number | any;
}
